import {handlerMsgURL, hasURL, pick, queryStrBuilder} from "@/lib/util";

export default (res) => {
  let reply = res.msgText || res.replyContent || "";
  let {msgType} = res;
  if (reply.indexOf('articleId') >= 0 && res.replyContent) {
    reply = JSON.parse(reply);
    return "医生文章：《<a href='#" + '/doc/article/' + reply.articleId + "'>" + reply.title + "</a>》"
  } else if (reply.indexOf('articleId') >= 0 && res.msgText) {
    reply = JSON.parse(reply);
    return "医生分享文章：《" + reply.title + "》"
  } else if (msgType === 'PRESCRIPTION') {
    reply = JSON.parse(reply);
    let map = pick({
      userId: 'patId',
      compatId: 'compatId',
      code: 'code'
    }, reply);
    let href = "#/prescription" + queryStrBuilder(map);
    const {auditStatus = ''} = reply;
    const className = auditStatus === 'NOPASS' ? 'color_red' : 'color_main';
    const text = auditStatus === 'NOPASS' ? '处方审核未通过，查看详情' : '点击查看处方详情，购买药品，并选择取药方式';
    return reply.title + '<br/>' + '<a href="' + href + '" class="' + className + '">' + text + '</a>';
  } else if (msgType === 'MEDICAL_RECORD') {
    reply = JSON.parse(reply);
    return reply;
  } else if (msgType === 'TEXT') {
    if (hasURL(reply)) {
      reply = handlerMsgURL(reply)
    }
    return reply;
  } else if (msgType === 'SURGERY_MISSION') {// 日间手术
    reply = JSON.parse(reply);
    return `<a style="text-decoration: underline" class="color_main" href="#/daysurgery/news/detail?newId=${reply.id}">${reply.title}</a>`
  } else if (msgType === 'CARD_MESSAGE') {
    reply = JSON.parse(reply);
    return reply;
  } else {
    return reply;
  }
}



// WEBPACK FOOTER //
// ./src/utils/msgItem.js